const TEXTS = {
	topTitle: 'Виджет оплаты счетов в ваших письмах',
	topDescription: 'Добавьте виджет в свои письма со счетами, и клиенты станут оплачивать их чаще и без задержек',

	managmentTitle: 'Работает на JSON LD',
	managmentJsonDescription: 'JSON LD — это простой формат передачи данных.' +
		' Вы размечаете свое письмо по определенным правилам, а Почта преобразует данные в удобный виджет оплаты.',
	managmentLetterImage: 'Разметка в письме',
	managmentDieImage: 'Что видит пользователь',
	managmentArgumentsTitle: 'Увеличивает конверсию в оплату',
	managmentArguments: [
		'Клиент быстрее заметит важную информацию в письме, и виджет побудит его к действию',
		'Для оплаты не нужно переходить на другой сайт, вспоминать логин и пароль от личного кабинета',
		'Почта запоминает данные карты, чтобы в следующий раз пользователю не пришлось снова их вводить',
	],

	stepsTitle: 'Как добавить виджет в свои письма?',
	steps: [
		'Получите уникальный идентификатор',
		'Подключитесь к платежной системе Деньги Mail.ru',
		'Настройте DKIM на своем домене',
		'Разметьте письма с помощью JSON LD',
	],

	inputFormTitle: 'Как это работает?',
	inputFormSelectBlockFirstTitle: 'Смотреть код',
	inputFormSelectBlockSecondTitle: 'Визуальный редактор',
};

export default TEXTS;
